import React from "react";
import { ShipmentReconciliationSummaryTile } from "../../summary-tile/shipmentReconciliationSummaryTile";
import { BillingReviewSummaryResponse, ShipmentReconciliationSummaryTileTypes, ShipmentReconciliationSummaryTypes, ShipmentWorkItemReviewStatus } from "../../../../app/data/shipment-reconciliation/models";
import XGSIcon from "../../../../ui-components/icon/xgsIcon";
import XGSIcons from "../../../../ui-components/icon/xgsIcons";
import "./billingReviewSummary.scss";

interface BillingReviewSummaryProps {
    summaryData: BillingReviewSummaryResponse,
    isLoading: boolean,
    onApply: any,
    isFiltersApplied: boolean
}

export const BillingReviewSummary: React.FC<BillingReviewSummaryProps> = ({ summaryData, isLoading, onApply, isFiltersApplied }) => {

    const getPendingReviewMessage = (pendingBillingReview: number) => {
        if (!pendingBillingReview) return "0";
        else return `${formatLongNumber(pendingBillingReview)}`;
    }

    const formatLongNumber = (num: number) => {
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (num >= 1_000) {
            return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return num.toString();
    }

    return (<div className="xgs-billing-review-summary">
        <div className="xgs-billing-review-summary__row">
            <ShipmentReconciliationSummaryTile
                tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
                type={ShipmentReconciliationSummaryTypes.PENDING_FOR_REVIEW}
                isLoading={isLoading}
                title="Pending Review"
                value={getPendingReviewMessage(+summaryData.pendingBillingReview)}
                legendDescription="Shipment work items which are pending for review, this means either there is a potential accessorial available for the shipment or the service failed for the shipment."
                onApply={() => { onApply(ShipmentWorkItemReviewStatus.PENDING) }}
            />
            <ShipmentReconciliationSummaryTile
                tileContentType={ShipmentReconciliationSummaryTileTypes.PROGRESS}
                type={ShipmentReconciliationSummaryTypes.REVIEW_PROGRESS}
                isLoading={isLoading}
                title="Review Progress"
                value={(summaryData && summaryData.compltedBillingReview && +summaryData.compltedBillingReview) ? +summaryData.compltedBillingReview : 0}
                legendDescription="Progress of review."
                totalValue={(summaryData && summaryData.pendingBillingReview && +summaryData.pendingBillingReview && summaryData.compltedBillingReview && +summaryData.compltedBillingReview) ? (+summaryData.pendingBillingReview) + (+summaryData.compltedBillingReview) : 0}
            />
             <ShipmentReconciliationSummaryTile
                tileContentType={ShipmentReconciliationSummaryTileTypes.INFO}
                type={ShipmentReconciliationSummaryTypes.REVIEWED}
                isLoading={isLoading}
                title="Reviewed"
                value={formatLongNumber(+summaryData.compltedBillingReview)}
                legendDescription="Shipment work items which have been reviewed already"
                onApply={() => { onApply(ShipmentWorkItemReviewStatus.REVIEWED) }}
            />
            {isFiltersApplied && <div className="xgs-billing-review-summary__row__filters-notification">
                  <XGSIcon
                    icon={XGSIcons.faExclamationCircle}
                    size="sm"
                    className="xgs-billing-review-summary__row__filters-notification__icon"
                  />
                  <div className="xgs-billing-review-summary__row__filters-notification__text">Filters applied to results below.</div>
                </div>
              }
        </div>
    </div>
    )
};